import classNames from 'classnames'
import React, { forwardRef, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import QtyNumberInput from '../../../QtyNumberInput'
import QtyCellLabelText from '../../../../Quantities/components/QtyCellLabelText'
import { nav } from '@stores'
import { VIPClientType } from '@modules/common/models/enums/VIPClientType'
import { getEnumValue } from '@utils/get-enum-value'
import { Checkbox, makeStyles } from '@material-ui/core'
import CheckBoxIcon from '@material-ui/icons/CheckBox'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'

export interface BookAndActualQtyProps {
  value: number
  handleInputChange: any
  isBooked: boolean
  onChange: any
  disabled: boolean
  onKeyDown: any
  autoFocus: boolean
  onFocus: any
  onMouseDown: any
  label?: string
  showCheckbox?: boolean
  isUnsized?: boolean
  onBlur?: () => void
  highlightQty?: boolean
  highlightDoors?: boolean
}

const useStyle = makeStyles(theme => ({
  draftQtyCell: {
    padding: '5px 0',
    backgroundColor: 'var(--grey3)'
  },
  draftQtyCellHighlight: {
    padding: '5px 0'
  },
  draftQtyLabel: {
    width: '90%'
  },
  bookActualQtyCheckbox: {
    color: theme.palette.text.primary
  },
  bookActualQtyUnCheckbox: {
    color: theme.palette.text.disabled
  }
}))

const BookAndActualQty = forwardRef<HTMLInputElement, BookAndActualQtyProps>(
  (
    {
      value,
      handleInputChange,
      isBooked,
      onChange,
      disabled,
      onKeyDown,
      autoFocus,
      onFocus,
      onMouseDown,
      label,
      showCheckbox = true,
      isUnsized,
      onBlur,
      highlightQty,
      highlightDoors
    },
    ref
  ) => {
    const { t } = useTranslation()
    const isRetail = useMemo(
      () => getEnumValue(VIPClientType.Internal) === nav.queryParams?.clientType,
      []
    )
    const classes = useStyle()
    return (
      <div className='flex column align-center justify-center w-100'>
        {showCheckbox ? (
          <div>
            <Checkbox
              onChange={onChange}
              disabled={disabled}
              checked={isBooked}
              className={
                isBooked ? classes.bookActualQtyCheckbox : classes.bookActualQtyUnCheckbox
              }
              size='small'
              color='default'
              icon={<CheckBoxOutlineBlankIcon fontSize='small' />}
              checkedIcon={<CheckBoxIcon fontSize='small' />}
            />
          </div>
        ) : null}
        <div
          className={classNames(
            'flex align-center column text-center w-100',
            highlightDoors ? classes.draftQtyCellHighlight : classes.draftQtyCell
          )}
        >
          <div className={classNames('text-ellipsis', classes.draftQtyLabel)}>
            <QtyCellLabelText
              translation={
                label ??
                (isUnsized
                  ? t('orderTable.quantity', 'QUANTITY')
                  : isRetail
                  ? t('orderTable.actualQty', 'DOOR QUANTITY')
                  : t('orderTable.actualQtyWHL', 'DRAFT QUANTITY'))
              }
            />
          </div>
          <QtyNumberInput
            onChange={handleInputChange}
            disabled={!isBooked || disabled}
            isReset={!isBooked}
            value={value}
            onKeyDown={onKeyDown}
            ref={ref}
            autoFocus={autoFocus}
            onFocus={onFocus}
            onMouseDown={onMouseDown}
            onBlur={onBlur}
            highlightInput={highlightQty}
          />
        </div>
      </div>
    )
  }
)

export default BookAndActualQty
